import type { TextLinkStyle } from '#types/styles'

/**
 * Picks just the text-link style props (`color`, `hoverColor`, `style`, `underline`) out of a
 * larger CMS style object so they can be forwarded into a `text-link` slot prop without leaking
 * unrelated styling fields.
 * @param style - The source style object.
 * @param style.textLinkColor - The text-link colour token.
 * @param style.textLinkHoverColor - The text-link hover colour token.
 * @param style.textLinkStyle - The text-link style variant.
 * @param style.textLinkUnderline - The underline mode (`'always'`, `'hover'`, etc.).
 * @returns Subset containing only the four text-link style fields.
 * @category Utils
 */
export const getTextLinkStyles = ({
  textLinkColor,
  textLinkHoverColor,
  textLinkStyle,
  textLinkUnderline
}: TextLinkStyle) => ({
  textLinkColor,
  textLinkHoverColor,
  textLinkStyle,
  textLinkUnderline,
})
